import React from 'react';
import { Box, Typography } from '@mui/material';
import WarningOutlinedIcon from '@mui/icons-material/WarningOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

const alertStyles = {
  attention: {
    backgroundColor: '#FFFFE0',
    color: '#6B6B47',
    icon: WarningOutlinedIcon,
  },
  info: {
    backgroundColor: '#E6F4FF',
    color: '#0A5685',
    icon: InfoOutlinedIcon,
  },
};

const CustomAlert = ({ type = 'attention', title, message }) => {
  const style = alertStyles[type];
  const Icon = style.icon;

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 1,
        backgroundColor: style.backgroundColor,
        p: 2,
        borderRadius: '15px',
        mb: 2,
      }}
    >
      <Icon sx={{ color: style.color }} />
      <Typography sx={{ color: style.color }} variant='body2'>
        {title && (
          <Box component='span' sx={{ fontWeight: 'bold', mr: 0.5 }}>
            {title}
          </Box>
        )}
        {message}
      </Typography>
    </Box>
  );
};

export const AttentionAlert = () => (
  <CustomAlert
    message='Introduce los datos tal y como aparecen en la documentación del pasajero'
    title='Atención:'
    type='attention'
  />
);

export const InfoAlert = () => (
  <CustomAlert
    message='no podrás modificar ni incluir datos fiscales adicionales al proveedor.'
    title='Una vez hayas confirmado la reserva,'
    type='info'
  />
);

export default CustomAlert;
